// extracted by mini-css-extract-plugin
export default {"wrapper":"Cd","form":"Dd","preference":"Ed","request":"Fd","job":"Gd","smallprint":"Hd","asterisk":"Id","success":"Jd","circle":"Kd"};